import React from 'react'
import { Box, Flex } from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingCartNavigationSummary } from '@mindfulchefuk/features/Cart/components/CartNavigation/Onboarding/OnboardingCartNavigationSummary'
import { CartButton } from '@mindfulchefuk/features/Cart/components/CartNavigation/CartButton'
import { NewestCartItem } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingCartNavButton/NewestCartItem'

export const OnboardingCartNavButton = () => {
  const {
    totalNumberOfRecipes,
    maximumRecipesForPortion,
    newestCartItem,
    toggleCartDrawer,
  } = useChooseRecipesContext()

  return (
    <Box ml="auto" position="relative">
      <NewestCartItem item={newestCartItem} />

      <Flex>
        <OnboardingCartNavigationSummary
          key="cart-navigation-summary"
          maxRecipes={maximumRecipesForPortion}
          totalRecipes={totalNumberOfRecipes}
        />
        <CartButton newestItem={!!newestCartItem} onClick={toggleCartDrawer}>
          {totalNumberOfRecipes}
        </CartButton>
      </Flex>
    </Box>
  )
}
